<nav *ngIf="navbarVersion === XmNavbarConfigVersion.First" class="navbar navbar-transparent" xmNavbarGuestBackground>
  <div class="xm-navbar-container justify-content-between mx-3">
    <div class="d-flex">
      <xm-navbar-logo-widget *ngIf="!navbarConfig.logoDisabled"></xm-navbar-logo-widget>
      <xm-navbar-arrow-back-widget *ngIf="!navbarConfig.arrowBackDisabled"></xm-navbar-arrow-back-widget>
      <xm-navbar-title-widget *ngIf="!navbarConfig.titleDisabled"></xm-navbar-title-widget>
    </div>

    <div class="d-flex align-items-center">
      <xm-navbar-search-widget *ngIf="!navbarConfig.searchDisabled"></xm-navbar-search-widget>
      <xm-navbar-notification-widget *ngIf="!navbarConfig.notificationDisabled"></xm-navbar-notification-widget>
      <xm-navbar-help-link-widget *ngIf="!navbarConfig.helpLinkDisabled"></xm-navbar-help-link-widget>
      <xm-navbar-language-menu-widget *ngIf="!navbarConfig.languageMenuDisabled"></xm-navbar-language-menu-widget>
      <xm-dynamic-widget-layout *ngIf="navbarLayout" [layouts]="navbarLayout"></xm-dynamic-widget-layout>
      <xm-navbar-toggle-widget></xm-navbar-toggle-widget>
    </div>
  </div>
</nav>

<nav *ngIf="navbarVersion === XmNavbarConfigVersion.Second" class="xm-navbar">
  <div class="xm-navbar-container">
    <xm-dynamic-widget-layout *ngIf="navbarLayout"
                              [layouts]="navbarLayout"
                              class="xm-navbar-widgets-container"></xm-dynamic-widget-layout>
  </div>
</nav>
